import PropTypes from 'prop-types';

export default {
  isEnabled: PropTypes.bool,
  rules: PropTypes.shape()
};
